import { FileIcon } from "../../../icons/fileIcon"
import {Button} from "../../ui/Button"
import {TextField} from "../../ui/TextField"
import { Formik, Form } from "formik"
import { useValidateFields} from "../../../utils/useValidateFields"
import { Select, SelectContent, SelectItem, SelectValue, SelectTrigger } from "../../ui/Dropdown"
import ReactPhoneInput from 'react-phone-input-2';
import el from '../../../locale/react-phone-input-2/el.json';
import { getDropdownOptions } from "../../../transactions/offer/offer"
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useSaveCustomerForm, useSaveKYCCustomerForm } from "../../../hooks/react-query/useOffer"
import { useToast } from "../../ui/Toast/useToast"
import { queryClient } from '../../../utils/queryClient';
import { TooltipComponent } from "../../ui/Tooltip"
import clsx from "clsx"
import ReactDatePicker, { registerLocale } from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import { CalendarIcon } from "../../../icons/calendarIcon"
import moment from "moment"
import * as locale from "date-fns/locale";
import { subYears } from "date-fns"
import { dateFormatter } from "../../../utils/formatter"

registerLocale("el", locale["el"]);

export const DocumentationFirst = ({ setCurrentStep, fields, isKYC, newCustomerForm,message }) => {
  const { orderId } = useParams();

    const [dropdownData, setDropdownData] = useState();

    const { mutate: saveForm } = useSaveCustomerForm();
    const { mutate: saveKYCForm } = useSaveKYCCustomerForm();
    const navigate = useNavigate();
    const { toast } = useToast();
    
    useEffect(() => {
        if (fields) {
            const dropdownItems = Object.values(fields).filter((value) => value.source !== undefined);
    
            const promises = dropdownItems.map(item =>
                getDropdownOptions(item.source).then((data) => ({ [item.source]: data.data }))
            );
    
            Promise.all(promises).then((results) => {
                // Combine results into a single object
                const combinedData = results.reduce((acc, result) => ({ ...acc, ...result }), {});
    
                // Update state with the combined data
                setDropdownData(combinedData);
            });
        }
    }, [fields]);
    // console.log(isKYC)
    return(
        <Formik 
            initialValues={Object.keys(fields)
                .reduce((result, key) => {
                    result[key] = newCustomerForm === null || newCustomerForm[key] === null ? '' : newCustomerForm[key];
                    return result;
                }, {})}
            initialErrors={false}
            isInitialValid={false}
            validationSchema={useValidateFields(fields,isKYC)}
            onSubmit={async (values, { setErrors }) => {
                if (isKYC) {
                    saveKYCForm(
                        { cncode: orderId, data: {doi:values.doi} },
                        {
                            onSuccess: (data) => {
                                if (data && data.data.status === 'fail') {
                                    let errors = {}
                                    data.exceptions.forEach(item => errors[item] = 'Διορθώστε το πεδίο')
                                    setErrors(errors)
                                    toast({
                                        variant: 'destructive',
                                        description: data.data.message ?? 'Something went wrong check the fields and try again.',
                                    });
                                } else if (data && data.data.status === 'success') {
                                    if (orderId !== data.data.cncode) {
                                        queryClient.invalidateQueries({ queryKey: ['Orders'] });
                                        navigate(`/track-your-car/details/${data.data.cncode}`);
                                    }
                                    setCurrentStep(3);
                                }
                            },
                        }
                  )
                } else {
                    saveForm(
                        { cncode: orderId, data: values },
                        {
                            onSuccess: (data) => {
                                if (data && data.data.status === 'fail') {
                                    let errors = {}
                                    data.exceptions.forEach(item => errors[item] = 'Διορθώστε το πεδίο')
                                    setErrors(errors)
                                    toast({
                                        variant: 'destructive',
                                        description: data.data.message ?? 'Something went wrong check the fields and try again.',
                                    });
                                } else if (data && data.data.status === 'success') {
                                    if (orderId !== data.data.cncode) {
                                        queryClient.invalidateQueries({ queryKey: ['Orders'] });
                                        navigate(`/track-your-car/details/${data.data.cncode}`);
                                    }
                                    setCurrentStep(3);
                                }
                            },
                        }
                    );
                }
          }}>
            {({ errors, values, setFieldValue, isValid, setErrors, handleBlur, setFieldTouched, ...props }) => {
                // console.log(values,errors) 
                return (
                <Form>
                    <div className="flex border-b pb-2  border-b-[#A5A5A5] justify-between">
                        <div className="flex gap-2 pl-4 items-center max-lg:z-[100]">
                            <div className="flex gap-2">
                                <FileIcon className={'stroke-black'}/>
                                <h5>Στοιχεία & Έγγραφα</h5>
                            </div>
                                <p className="text-body max-lg:hidden">• Βήμα 1/2 Φόρμα Νέου Πελάτη</p>
                                <p className="text-body lg:hidden">Βήμα 1/2 Φόρμα Νέου Πελάτη</p>
                                <TooltipComponent side="bottom" content={<p className="flex flex-wrap lg:w-[400px] w-[200px]">Πριν από την υπογραφή των συμβολαίων, θα σου ζητηθεί να ανεβάσεις την ταυτότητά σου ώστε να γίνει Ταυτοποίηση Χρήστη.<br/> <br/>Συμπλήρωσε σωστά τον αριθμό του κινητού σου στο αντίστοιχο πεδίο ώστε να λάβεις τον κωδικό επιβεβαίωσης για την ολοκλήρωση της υπογραφής.</p>}>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.416504" y="0.75" width="16.5" height="16.5" rx="8.25" stroke="#A5A5A5" strokeWidth="0.5"/>
                            <path d="M8.66748 6.3396V6.33301" stroke="#6A6A6A" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M8.66748 11.666V7.93262" stroke="#6A6A6A" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M8.6667 14.2002C11.5386 14.2002 13.8667 11.8721 13.8667 9.0002C13.8667 6.12832 11.5386 3.8002 8.6667 3.8002C5.79482 3.8002 3.4667 6.12832 3.4667 9.0002C3.4667 11.8721 5.79482 14.2002 8.6667 14.2002Z" stroke="#6A6A6A" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        </TooltipComponent>
                        </div>
                        <Button type="submit" disabled={!isValid}  className={'max-lg:hidden disabled:bg-[#A5A5A5] bg-[#D4002A] px-5 py-2.5 rounded-full text-white text-primary-button'}>Επόμενο</Button>
                        </div>
                        {message !== '' &&
                        <div className="p-3 bg-[#FFD5D5] rounded-[12px] mt-4 text-body">
                          {message}
                        </div>}
                        <div className={clsx("lg:container lg:mx-auto py-10 p-5 lg:px-16 grid gap-5", isKYC ? 'grid-cols-2' : 'lg:grid-cols-2')}> 
                            {!isKYC ? Object.keys(fields).map(key => {
                                if (fields[key].htmlType !== 'dropdown' && fields[key].htmlType !== 'phone' && fields[key].htmlType !== 'date') {
                                    return <TextField value={values[key]} key={key}
                                        id={key} error={props.touched[key] && errors[key]} type={fields[key].htmlType} label={`${fields[key].label} ${fields[key].required ? '*' : ''}`} className={'w-full'}
                                        onChange={(e) => {
                                            let value = e.target.value
                                            setFieldValue([key], value)
                                        }}
                                        placeholder={fields[key].label}
                                        onBlur={handleBlur} />
                                } else if (fields[key].htmlType === 'date') {
                                    let initValue = ''
                                    if (values[key] !== '') {
                                        const [day, month, year] = values[key].split('/');
                                        initValue =new Date(year, month - 1, day);
                                    }
                                    return (
                                        <div className="flex flex-col gap-1">
                                        <p className="text-label text-[#C1C1C1]">{`${fields[key].label} ${fields[key].required ? '*' : ''}`}</p>
                                            <ReactDatePicker
                                                locale={'el'}
                                                showMonthDropdown
                                                maxDate={key === 'birthDate' && dateFormatter(subYears(new Date(), 18))}
                                                showYearDropdown
                                                dropdownMode='select'
                                                calendarIconClassname="top-[2px]"
                                                icon={<CalendarIcon className={'stroke-black'} />}
                                                showIcon
                                                className=" border border-[#A5A5A5] focus:ring-none flex gap-2 rounded-[8px] border border-[#A5A5A5] p-2 bg-white w-full"
                                                enableTabLoop={false}
                                                placeholderText="dd/mm/yyyy"
                                                dateFormat='dd/MM/yyyy'
                                                selected={initValue}
                                                onCalendarClose={() => { setFieldTouched([key], true) } }
                                                onChange={(date) => { date !==null ? setFieldValue([key], moment(date).format('DD/MM/YYYY')) : setFieldValue([key], '')}}
                                            />
                                            {props.touched[key] && errors[key] && (
                                            <p className="text-label text-primary">
                                                {errors[key]}
                                            </p>
                                        )}
                                    </div>
                                    )
                                }
                                else if (fields[key].htmlType === 'dropdown') {
                                    return (
                                        <div className="flex flex-col gap-1">
                                            <p className="text-label text-[#C1C1C1]">{`${fields[key].label} ${fields[key].required ? '*' : ''}`}</p>
                                            <Select defaultValue={values[key]} onOpenChange={(open)=>{ if(!open) setFieldTouched([key], true)}} onValueChange={(value) => { setFieldValue([key], value) }}>
                                                <SelectTrigger className="w-[180px]">
                                                    <SelectValue placeholder={fields[key].label} />
                                                </SelectTrigger>
                                                <SelectContent>
                                                    {
                                                        Object.entries(dropdownData ? dropdownData[fields[key].source] ?? {} : {}).map(([innerKey, innerValue]) =>
                                                            <SelectItem value={innerKey}>{innerValue}</SelectItem>
                                                        )}
                                                </SelectContent>
                                            </Select>
                                            {errors[key] && props.touched[key] && (
                                            <p className="text-label text-primary">
                                                {errors[key]}
                                            </p>
                                        )}
                                        </div>
                                    )
                                }
                                else {
                                    return (<div className="flex flex-col gap-1">
                                        <label
                                            htmlFor={[key]}
                                            className="text-label text-fadedgrey"
                                        >
                                            {fields[key].label} {fields[key].required ? '*' : ''}
                                        </label>
                                        <ReactPhoneInput
                                            key={[key]}
                                            id={[key]}
                                            onClick={()=>{ setFieldTouched([key], true) }}
                                            country="gr"
                                            countryCodeEditable={false}
                                            autoFormat={false}
                                            containerClass={`flex gap-2 rounded-[8px] bg-white ${errors.hasOwnProperty(key) && props.touched[key]
                                                    ? 'border border-primary'
                                                    : 'border border-[#A5A5A5]'
                                                }`}
                                            inputStyle={{
                                                width: '100%',
                                                border: 'none',
                                            }}
                                            localization={el}
                                            specialLabel="Phone"
                                            value={values[key][0] === '+' ? values[key] : '+' + values[key]}
                                            placeholder=""
                                            onChange={(value, event) => {
                                                if (value === '30') {
                                                    setFieldValue([key], '')
                                                } else {
                                                    setFieldValue([key], '+' + value);
                                                }
                                            }}
                                            inputProps={{
                                                name: [key],
                                                required: true,
                                            }}
                                        />
                                        {props.touched[key] && errors[key] && (
                                            <p className="text-label text-primary">
                                                {errors[key]}
                                            </p>
                                        )}
                                    </div>
                                    )
                                }
                            }) :
                                Object.keys(newCustomerForm).map(key => { 
                                    if (fields[key] && newCustomerForm[key] !== null)
                                        return (
                                            <div className="flex flex-col gap-2">
                                                <p className="text-[#6A6A6A] text-body">{fields[key].label}</p>
                                                <p className="text-body-large">{newCustomerForm[key] === '' ? '-' : newCustomerForm[key]}</p>
                                            </div>
                                        )
                                        else if(fields[key] && newCustomerForm[key] ===null && key !== 'occupation'){
                                            if (fields[key].htmlType !== 'dropdown' && fields[key].htmlType !== 'phone') {
                                                return <TextField key={key}
                                                    id={key} error={props.touched[key] && errors[key]} type={fields[key].htmlType} label={`${fields[key].label} ${fields[key].required ? '*' : ''}`} className={'w-full'}
                                                    onChange={(e) => {
                                                        let value = e.target.value
                                                        if (fields[key].htmlType === 'date') {
                                                            const parts = e.target.value.split('-');
                                                            value = `${parts[2]}/${parts[1]}/${parts[0]}`;
                                                      
                                                        }
                                                        setFieldValue([key], value)
                                                    }}
                                                    placeholder={fields[key].label}
                                                    onBlur={handleBlur} />
                                            }
                                            else if (fields[key].htmlType === 'dropdown') {
                                                return (
                                                    <div className="flex flex-col gap-1 max-lg:col-span-2 order-first">
                                                        <p className="text-label text-[#C1C1C1]">{`${fields[key].label} ${fields[key].required ? '*' : ''}`}</p>
                                                        <Select onValueChange={(value) => { setFieldValue([key], value) }}>
                                                            <SelectTrigger className="w-[180px]">
                                                                <SelectValue placeholder={fields[key].label} />
                                                            </SelectTrigger>
                                                            <SelectContent>
                                                                {
                                                                    Object.entries(dropdownData ? dropdownData[fields[key].source] ?? {} : {}).map(([innerKey, innerValue]) =>
                                                                        <SelectItem value={innerKey}>{innerValue}</SelectItem>
                                                                    )}
                                                            </SelectContent>
                                                        </Select>
                                                    </div>
                                                )
                                            }
                                        }
                                })
                               
                        }   
                        <Button type="submit" disabled={!isValid}  className={'lg:hidden disabled:bg-[#A5A5A5] bg-[#D4002A] px-5 py-2.5 rounded-[6px] text-white text-sm font-[600] col-span-2'}>Επόμενο</Button>    
                        </div>
                </Form>
       )}}
        </Formik>
    )
}